function readBoolean(value: string | undefined): boolean {
  return value?.trim().toLowerCase() === 'true'
}

export const env = {
  TENCENTCLOUD_SCF_FUNCTION_NAME: process.env.TENCENTCLOUD_SCF_FUNCTION_NAME,
  TENCENTCLOUD_SCF_REGION: process.env.TENCENTCLOUD_SCF_REGION ?? 'ap-shanghai',
  TENCENTCLOUD_SCF_NAMESPACE: process.env.TENCENTCLOUD_SCF_NAMESPACE ?? 'default',
  TENCENTCLOUD_SCF_LAYER_NAME: process.env.TENCENTCLOUD_SCF_LAYER_NAME,
  TENCENTCLOUD_SCF_REPLACE_LAYER_NAME: process.env.TENCENTCLOUD_SCF_REPLACE_LAYER_NAME,
  TENCENTCLOUD_SCF_LAYER_BUCKET: process.env.TENCENTCLOUD_SCF_LAYER_BUCKET,
  TENCENTCLOUD_SCF_LAYER_BUCKET_REGION: process.env.TENCENTCLOUD_SCF_LAYER_BUCKET_REGION,
  TENCENTCLOUD_SCF_LAYER_PREFIX: process.env.TENCENTCLOUD_SCF_LAYER_PREFIX ?? 'layers',
  TENCENTCLOUD_SCF_LAYER_RUNTIME: process.env.TENCENTCLOUD_SCF_LAYER_RUNTIME,
  TENCENTCLOUD_SCF_LAYER_USE_ACCELERATE: readBoolean(process.env.TENCENTCLOUD_SCF_LAYER_USE_ACCELERATE),
  TENCENTCLOUD_SCF_SECRET_ID: process.env.TENCENTCLOUD_SCF_SECRET_ID,
  TENCENTCLOUD_SCF_SECRET_KEY: process.env.TENCENTCLOUD_SCF_SECRET_KEY
}
